import ICMAxios from "../ICMAxios";

const getInventorySetting = async()=>{
    const response = await ICMAxios.get(`v1/InventorySettings`);
    return response.data;
}

const addInventorySetting = async(settingData: any)=>{
    const response = await ICMAxios.post(`v1/InventorySettings`, settingData);
    return response.data;
}

const updateInventorySetting = async(settingData: any)=>{
    const response = await ICMAxios.put(`v1/InventorySettings`, settingData);
    return response.data;
}

const adminSettingService = { getInventorySetting, addInventorySetting, updateInventorySetting }

export default adminSettingService;